import React, { useState, useEffect } from "react";
import Select from "react-select";

const style = {
  control: (base, state) => ({
    ...base,
    alignItems: "center",
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: state.isDisabled ? "#F9FBFC" : "#FFFFFF",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000811",
    whiteSpace: "nowrap",
  }),
  valueContainer: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    minHeight: "33px",
    height: "33px",
    padding: "0 10px",
    overflow: "hidden",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    lineHeight: "1.2",
  }),
  singleValue: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    height: "100%",
    margin: 0,
    maxWidth: "100%",
    position: "static",
    top: "auto",
    transform: "none",
    lineHeight: "1.2",
  }),
  placeholder: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    height: "100%",
    margin: 0,
    position: "static",
    top: "auto",
    transform: "none",
    lineHeight: "1.2",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    alignItems: "center",
    height: "33px",
  }),
  clearIndicator: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    height: "33px",
    justifyContent: "center",
    padding: 0,
    width: "32px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    height: "33px",
    justifyContent: "center",
    padding: 0,
    width: "32px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    alignSelf: "center",
    height: "20px",
    marginBottom: 0,
    marginTop: 0,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 100000,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 100000,
  }),
};

const isSameOption = (first, second) => {
  if (!first && !second) return true;
  if (!first || !second) return false;

  return String(first.value) === String(second.value) && String(first.label) === String(second.label);
};

const areSameOptions = (firstList = [], secondList = []) => {
  if (firstList.length !== secondList.length) return false;

  return firstList.every((item, index) => isSameOption(item, secondList[index]));
};

export const DropDownComponent = ({
  isDisabled,
  placeHolder,
  pageName,
  dpDownName,
  stateData,
  controlName,
  handleChange,
  value,
  valueId,
  setState,
  checkLabel,
  components,
  refComp,
  inputId,
  menuPortalTarget,
  customStyles,
  hideSelectedOptions,
  multiSelect = false,
  syncValue = true,
}) => {
  const [dropdownOption, setDropdownOption] = useState([]);
  const selectValue = multiSelect
    ? (Array.isArray(value) ? value : [])
    : (Array.isArray(value) ? null : value || null);
  const resolvedMenuPortalTarget =
    menuPortalTarget !== undefined
      ? menuPortalTarget
      : typeof document !== "undefined"
        ? document.body
        : null;
  useEffect(() => {
    const GetData = () => {
      if (stateData) {
        let list = FormatdrpOption(stateData);
        setDropdownOption((currentList) =>
          areSameOptions(currentList, list) ? currentList : list
        );
      }
    };
    GetData();
  }, [stateData]);

  useEffect(() => {
    if (!syncValue) return;

    if (!dropdownOption?.length) {
      if (!valueId && typeof setState === "function" && value !== null) {
        setState(null);
      }
      return;
    }

    const selectedValues = Array.isArray(valueId) ? valueId : [valueId];
    const selectedValue = multiSelect
      ? dropdownOption.filter((item) =>
          selectedValues.some((selected) =>
            String(checkLabel ? item.label : item.value) === String(selected)
          )
        )
      : dropdownOption.find(
          (item) => String(checkLabel ? item.label : item.value) === String(valueId)
        ) || null;
    const valuesMatch = multiSelect
      ? areSameOptions(Array.isArray(value) ? value : [], selectedValue)
      : isSameOption(value, selectedValue);

    if (typeof setState === "function" && !valuesMatch) {
      setState(selectedValue);
    }
  }, [dropdownOption, valueId, checkLabel, setState, value, multiSelect, syncValue]);

  const FormatdrpOption = (list) => {
    var te = list?.map((data, index) => ({
      ...data,
      label: GetLabel(data),
      value: GetId(data),
    }));
    return te;
  };
  const GetLabel = (data) => {

    if (dpDownName === "designation") return data?.designationName;
    else if (dpDownName === "department") return data?.departmentName;
    else if (["designConsultantData", "orderType"].includes(dpDownName)) return data?.label;
    else if (dpDownName === "assignedTo" || dpDownName === "salesengineer" || dpDownName === "allocatedTo")
      return (
        data?.fullName ||
        data?.engineerName ||
        data?.employeeName ||
        data?.name ||
        data?.label ||
        `${data?.firstName ?? ""} ${data?.lastName ?? ""}`.trim()
      );
    else if (dpDownName === "projectsegment") return data?.segmentName;
    else if (dpDownName === "projectstatus") return data?.statusName;
    else if (dpDownName === "customer") return data?.customerName;
    else if (dpDownName === "orderRef") return data?.customerOrderReference || data?.orderReference;
    else if (dpDownName === "quoteRef") return data?.quoteReference;
    else if (dpDownName === "distributor") return data?.distributorName;
    else if (dpDownName === "mainContractor") return data?.customerName;
    else if (dpDownName === "mepContractor") return data?.customerName;
    else if (dpDownName === "client") return data?.customerName;
    else if (dpDownName === "superVision") return data?.customerName;
    else if (dpDownName === "country") return data?.name;
    else if (dpDownName === "status" || dpDownName === "quotevalidity" || dpDownName === "projectreference")
      return data?.label;
    else if (dpDownName === "project") return data?.projectName;
    else if (dpDownName === "paymentterms") return data?.paymentDescription;
    else if (dpDownName === "deliveryterms") return data?.deliveryDescription;
    else if (dpDownName === "transportmode") return data?.transportationMode;
    else if (dpDownName === "enquiry") return data?.inquiryRef;
    else if (dpDownName === "currency") return data?.currencyName;
    else if (dpDownName === "currencyCode") return data?.shortCode;
    else if (dpDownName === "company") return data?.companyName;
    else if (dpDownName === "customerStatus") return data?.status;
    else if (dpDownName === "facility") return data?.facilityName || data?.facilityCode;
    else if (dpDownName === "inquiryTypesdrp") return data?.type;
    else if (dpDownName === "distributorTypesdrp") return data?.typeName;
    else if (dpDownName === "lostreason") return data?.quoteLostReason;
    else if (dpDownName === "quotestatus") return data?.statusDesc;
    else if (dpDownName === "role") return data?.name
    else if (dpDownName === "productGroup") return data?.group
    else if (dpDownName === "productFamily") return data?.family
    else if (dpDownName === "quotationId") return data?.quotationReference
    else return "";
  };
const GetId = (data) => {
  if (
    dpDownName === "allocatedTo" ||
    dpDownName === "assignedTo" ||
    dpDownName === "salesengineer"
  )
    return data?.identityId;

  else if (
    ["status", "orderType", "quotevalidity", "projectreference"].includes(dpDownName)
  )
    return data?.value;

  else if (dpDownName === "quotationId")
    return data?.quotationId;

  else if (dpDownName === "orderRef")
    return data?.customerOrderId || data?.id;

  else
    return data?.id;
};

  return (
    <Select
      name={controlName}
      inputId={inputId}
      options={dropdownOption}
      className="basic-multi-select"
      classNamePrefix="react-select"
      onChange={handleChange}
      value={selectValue}
      styles={{ ...style, ...customStyles }}
      placeholder={placeHolder}
      hideSelectedOptions={hideSelectedOptions}
      menuPortalTarget={resolvedMenuPortalTarget}
      menuPosition={resolvedMenuPortalTarget ? "fixed" : "absolute"}
      menuPlacement="auto"
      minMenuHeight={0}
      theme={(theme) => ({
        ...theme,
        colors: { ...theme.colors, neutral80: "#000000" },
      })}
      isDisabled={isDisabled}
      isMulti={multiSelect}
      isClearable={!["customerStatus", "role"].includes(dpDownName)}
      components={components}
      ref={refComp}
    />
  );
};
